var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c160a37843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 266.410156 23.820312 L 326.5 23.820312 L 326.5 83.914062 L 266.410156 83.914062 Z M 266.410156 23.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "86796c0726"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 296.453125 23.820312 C 279.859375 23.820312 266.410156 37.273438 266.410156 53.867188 C 266.410156 70.460938 279.859375 83.914062 296.453125 83.914062 C 313.046875 83.914062 326.5 70.460938 326.5 53.867188 C 326.5 37.273438 313.046875 23.820312 296.453125 23.820312 Z M 296.453125 23.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbf98d6f8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 236.363281 315.648438 L 266.410156 315.648438 L 266.410156 345.695312 L 236.363281 345.695312 Z M 236.363281 315.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "354bf8113c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 251.386719 315.648438 C 243.089844 315.648438 236.363281 322.375 236.363281 330.671875 C 236.363281 338.96875 243.089844 345.695312 251.386719 345.695312 C 259.683594 345.695312 266.410156 338.96875 266.410156 330.671875 C 266.410156 322.375 259.683594 315.648438 251.386719 315.648438 Z M 251.386719 315.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "34c6d940d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.527344 3.75 L 358.472656 3.75 L 358.472656 345.695312 L 16.527344 345.695312 Z M 16.527344 3.75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0eb3c37801"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 3.75 C 93.074219 3.75 16.527344 80.296875 16.527344 174.722656 C 16.527344 269.148438 93.074219 345.695312 187.5 345.695312 C 281.925781 345.695312 358.472656 269.148438 358.472656 174.722656 C 358.472656 80.296875 281.925781 3.75 187.5 3.75 Z M 187.5 3.75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17c2bd30ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.167969 120.773438 L 184.417969 120.773438 L 184.417969 273.023438 L 50.167969 273.023438 Z M 50.167969 120.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4f944f8ea6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 137.207031 47.117188 L 184.421875 47.117188 L 184.421875 273.03125 L 137.207031 273.03125 Z M 137.207031 47.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6fa9c15ec0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 190.707031 120.773438 L 324.957031 120.773438 L 324.957031 273.023438 L 190.707031 273.023438 Z M 190.707031 120.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab275029f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 163.128906 143 L 214.683594 143 L 214.683594 244.628906 L 163.128906 244.628906 Z M 163.128906 143 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03a3e2a918"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.90625 244.628906 C 174.671875 244.628906 163.128906 233.085938 163.128906 218.851562 L 163.128906 168.792969 C 163.128906 154.554688 174.671875 143.015625 188.90625 143.015625 C 203.144531 143.015625 214.683594 154.554688 214.683594 168.792969 L 214.683594 218.851562 C 214.683594 233.085938 203.144531 244.628906 188.90625 244.628906 Z M 188.90625 244.628906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c6f59bd63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 173.421875 152.894531 L 206.078125 152.894531 L 206.078125 236.453125 L 173.421875 236.453125 Z M 173.421875 152.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2dbc02a7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 189.75 152.894531 C 198.769531 152.894531 206.078125 160.203125 206.078125 169.222656 L 206.078125 220.03125 C 206.078125 229.050781 198.769531 236.359375 189.75 236.359375 C 180.730469 236.359375 173.421875 229.050781 173.421875 220.03125 L 173.421875 169.222656 C 173.421875 160.203125 180.730469 152.894531 189.75 152.894531 Z M 189.75 152.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b64429295d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39 89 L 174 89 L 174 159.734375 L 39 159.734375 Z M 39 89 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c160a37843)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#86796c0726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M 266.410156 23.820312 L 326.5 23.820312 L 326.5 83.914062 L 266.410156 83.914062 Z M 266.410156 23.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bbf98d6f8f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#354bf8113c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M 236.363281 315.648438 L 266.410156 315.648438 L 266.410156 345.695312 L 236.363281 345.695312 Z M 236.363281 315.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#34c6d940d8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0eb3c37801)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 16.527344 3.75 L 358.472656 3.75 L 358.472656 345.695312 L 16.527344 345.695312 Z M 16.527344 3.75 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17c2bd30ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 70.914062 251.84375 C 84.960938 265.699219 104.957031 273.027344 128.746094 273.027344 L 184.421875 273.027344 L 184.328125 267.265625 C 184.085938 252.320312 176.847656 240.816406 163.390625 233.996094 C 153.214844 228.839844 141.710938 227.410156 133.855469 227.117188 L 128.191406 227.113281 C 109.394531 227.113281 98.175781 215.929688 98.175781 197.199219 L 98.175781 196.796875 C 98.175781 177.789062 109.117188 166.886719 128.191406 166.886719 L 134.207031 166.886719 L 134.429688 166.882812 C 142.363281 166.570312 153.941406 165.097656 164.054688 159.878906 C 177.320312 153.027344 184.335938 141.535156 184.335938 126.640625 L 184.335938 120.972656 L 129.488281 120.972656 C 105.578125 120.972656 85.394531 128.515625 71.121094 142.785156 C 57.332031 156.566406 50.046875 175.449219 50.046875 197.398438 L 50.046875 197.804688 C 50.046875 219.6875 57.261719 238.375 70.914062 251.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f944f8ea6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 137.207031 47.117188 L 184.421875 47.117188 L 184.421875 273.039062 L 137.207031 273.039062 Z M 137.207031 47.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6fa9c15ec0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 211.453125 251.84375 C 225.5 265.699219 245.496094 273.027344 269.285156 273.027344 L 324.960938 273.027344 L 324.867188 267.265625 C 324.628906 252.320312 317.386719 240.816406 303.933594 233.996094 C 293.753906 228.839844 282.25 227.410156 274.394531 227.117188 L 268.730469 227.113281 C 249.9375 227.113281 238.714844 215.929688 238.714844 197.199219 L 238.714844 196.796875 C 238.714844 177.789062 249.65625 166.886719 268.730469 166.886719 L 274.746094 166.886719 L 274.96875 166.882812 C 282.902344 166.570312 294.480469 165.097656 304.59375 159.878906 C 317.859375 153.027344 324.875 141.535156 324.875 126.640625 L 324.875 120.972656 L 270.027344 120.972656 C 246.117188 120.972656 225.933594 128.515625 211.660156 142.785156 C 197.871094 156.566406 190.585938 175.449219 190.585938 197.398438 L 190.585938 197.804688 C 190.585938 219.6875 197.800781 238.375 211.453125 251.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab275029f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03a3e2a918)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 214.683594 244.628906 L 163.128906 244.628906 L 163.128906 142.925781 L 214.683594 142.925781 Z M 214.683594 244.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c6f59bd63)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2dbc02a7e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 173.421875 152.894531 L 206.078125 152.894531 L 206.078125 236.328125 L 173.421875 236.328125 Z M 173.421875 152.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b64429295d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 173.3125 140.070312 C 173.589844 139.792969 173.632812 139.363281 173.40625 139.042969 C 173.308594 138.910156 163.800781 125.578125 148.269531 112.917969 C 139.136719 105.472656 129.734375 99.710938 120.320312 95.78125 C 108.523438 90.859375 96.679688 88.828125 85.125 89.734375 C 72.503906 90.730469 62.0625 94.296875 54.109375 100.332031 C 47.082031 105.667969 42.414062 112.683594 40.617188 120.617188 C 37.5 134.390625 43.789062 148.453125 56.269531 155.613281 C 61.378906 158.542969 66.382812 159.761719 71.292969 159.757812 C 84.46875 159.757812 96.867188 150.957031 108.160156 142.9375 C 115.40625 137.792969 122.25 132.933594 128.730469 130.671875 C 148.839844 123.652344 172.050781 139.988281 172.285156 140.152344 C 172.601562 140.378906 173.035156 140.347656 173.3125 140.070312 Z M 173.3125 140.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 158.457031 65.144531 C 152.6875 63.003906 147.613281 64.625 144.171875 69.71875 C 137.246094 79.96875 146.753906 88.664062 157.761719 98.734375 C 167.183594 107.351562 177.867188 117.125 181.710938 130.242188 C 181.8125 130.585938 182.128906 130.816406 182.480469 130.816406 C 182.5 130.816406 182.527344 130.816406 182.546875 130.8125 C 182.925781 130.78125 183.230469 130.488281 183.277344 130.113281 C 187.511719 95.308594 171.585938 70.019531 158.457031 65.144531 Z M 158.457031 65.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5d529c04fbe6ee9dce9e24b5e6e32fd4.svg";
export { ForwardRef as ReactComponent };